module.exports = __webpack_public_path__ + "img/industry_example_en.eb8bab61.jpg";